var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIconFacebook63C5Fa61692Db577045C971910963D3F(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.536,
    height: 29.536,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16649",
    d: "M14.768 0a14.768 14.768 0 1014.768 14.768A14.768 14.768 0 0014.768 0zm3.681 10.032h-1.335c-1.046 0-1.249.5-1.249 1.227v1.609h2.5l-.325 2.521h-2.175v6.467h-2.6v-6.467h-2.178v-2.521h2.176v-1.859a3.037 3.037 0 013.242-3.331 17.706 17.706 0 011.945.1z",
    fill: "#3a589e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconFacebook63C5Fa61692Db577045C971910963D3F);
export default __webpack_public_path__ + "static/media/social-icon-facebook.63c5fa61692db577045c971910963d3f.decda22ac5acf5c7d0a8476880bc5fb0.svg";
export { ForwardRef as ReactComponent };